var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{staticClass:"badge-status",attrs:{"pill":"","variant":_vm.computedVariant}},[_c('b-icon',{attrs:{"icon":_vm.computedIcon}}),_c('span',[_vm._v(_vm._s(_vm.status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }